var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history_css",attrs:{"id":"open-mini-program"},on:{"click":_vm.goWx_}},[_vm._v("小程序 Go")])
}
var staticRenderFns = []

export { render, staticRenderFns }